import React from 'react'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

interface ButtonWithIconProps {
  nameButton: string
  icon: JSX.Element
  onClick: () => void
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  variant?: 'text' | 'outlined' | 'contained'
  fullWidth?: boolean
}

const ButtonWithIcon: React.FC<ButtonWithIconProps> = (props: ButtonWithIconProps): JSX.Element => {
  return (
    <Button fullWidth={props.fullWidth} disabled={props.disabled} variant={props.variant} size={props.size} startIcon={props.icon} onClick={props.onClick}>
      <Typography sx={{ fontSize: { sm: 10, lg: 15 } }}>
        {props.nameButton}
      </Typography>
    </Button>
  )
}

ButtonWithIcon.defaultProps = {
  size: 'medium',
  variant: 'contained',
  disabled: false,
  fullWidth: false
}

export default ButtonWithIcon
